import type { LoanSummaryDto } from "@/api/portfolioAdmin/types";
import { LoanFeeReviewSection } from "@/components/portfolioAdmin/loanDetail/financials/LoanFeeReviewSection";
import { LoanFeesPanel } from "@/components/portfolioAdmin/loanDetail/financials/LoanFeesPanel";
import { LoanObligationsPanel } from "@/components/portfolioAdmin/loanDetail/financials/LoanObligationsPanel";
import { StandingWorksheetSection } from "@/components/portfolioAdmin/loanDetail/financials/StandingWorksheetSection";
import { IncomePoolsForwardSection } from "@/components/portfolioAdmin/loanDetail/financials/IncomePoolsForwardSection";

interface FeeObligationTabProps {
  loan: LoanSummaryDto;
}

/**
 * Fee & Obligation tab (Fee & Obligation PR-1) — the loan's single home for
 * fee entry, the B3 review queue, and the waterfall-connected obligation
 * ledger. Deep link: ?tab=fee-obligation.
 *
 * Stack (top → bottom): the loan-scoped B3 fee review section (self-gates on
 * Fees.Review), the Fees ledger (entry via the review pipeline — approved
 * fees bill on the next statement and collect through the waterfall), and
 * Obligations / Cost-Recovery. The Add Obligation wizard replaces the Add Fee
 * form in PR-2; the standing worksheet + Income Pools sections (PR-5) close the
 * stack — a forward projection of the next statements and booked-vs-expected
 * pool income.
 */
export function FeeObligationTab({ loan }: FeeObligationTabProps) {
  return (
    <div className="flex flex-col gap-space-4" data-testid="fee-obligation-tab">
      <LoanFeeReviewSection loanId={loan.id} />
      <LoanFeesPanel loanId={loan.id} />
      <LoanObligationsPanel loanId={loan.id} />
      <StandingWorksheetSection loanId={loan.id} />
      <IncomePoolsForwardSection loanId={loan.id} />
    </div>
  );
}
